import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Routes } from "src/app/infrastructure/routes";
import { PalletStockGateway } from "../gateway/PalletStockGateway";
import { CreateFormatPalletStockRequest, CreatePalletRequestAdmin, CreatePalletStockRequest, FormatPalletStock, GroupPalletStock, GroupPalletStockRequest, PalletStock, PalletStockFilter, PalletStockImport, PalletStockListFilter, PalletStockPreviewRequest, PalletStockPreviewResponse, PalletStockStats, Stock, StockColumn, UpdateFormatPalletStock, UpdatePalletStockRequest, UpdatePalletStockRequestAdmin } from "src/app/domain/models/PalletStock";
import { PageResult } from "src/app/domain/models/PageResult";


@Injectable({providedIn: 'root'})
export class PalletStockService extends PalletStockGateway
{
  constructor(private _http: HttpClient)
  {
    super()
  }

  getPalletStock(stockId: number): Observable<PalletStock[]> {
    return this._http.get<PalletStock[]>(Routes.palletStockApi + '/GetPalletStock', {params: {stockId}})
  }

  getPalletStockStats(stockId: number): Observable<PalletStockStats>{
      return this._http.get<PalletStockStats>(Routes.palletStockApi + '/GetPalletStockStats', {params: {stockId}})
  }

  getPalletStockPaged(request: PalletStockFilter): Observable<PageResult<PalletStock>> {
    return this._http.get<PageResult<PalletStock>>(Routes.palletStockApi + '/GetPalletStockPaged', {params: {... request}})
  }

  getPalletStockFilter(stockId: number): Observable<PalletStockListFilter> {
    return this._http.get<PalletStockListFilter>(Routes.palletStockApi + '/GetPalletStockFilter', {params: {stockId}})
  }

  getGroupPalletStock(request: GroupPalletStockRequest):  Observable<PageResult<GroupPalletStock>> {
    return this._http.get<PageResult<GroupPalletStock>>(Routes.palletStockApi + '/GetGroupPalletStock', {params: {...request}})
  }

  getPalletStockUnused(stockId: number): Observable<PalletStock[]> {
    return this._http.get<PalletStock[]>(Routes.palletStockApi + '/GetPalletStockUnused', {params: {stockId}})
  }

  getFormatPalletStock(): Observable<FormatPalletStock[]> {
     return this._http.get<FormatPalletStock[]>(Routes.palletStockApi + '/GetFormatPalletStock')
  }

  getFormatPalletStockAdmin(username: string): Observable<FormatPalletStock[]>
  {
    return this._http.get<FormatPalletStock[]>(Routes.palletStockApi + '/GetFormatPalletStockAdmin', {params: {username}})
  }

  createPalletStock(request: CreatePalletStockRequest): Observable<any> {
    return this._http.post<any>(Routes.palletStockApi + '/CreatePalletStock', this.getFormDataCreate(request))
  }

  createPalletStockAdmin(request: CreatePalletRequestAdmin): Observable<PalletStock[]>
  {
    return this._http.post<PalletStock[]>(Routes.palletStockApi + '/CreatePalletStockAdmin', this.getFormDataCreateAdmin(request), {params: {username: request.username}})
  }

  updatePalletStock(request: UpdatePalletStockRequest): Observable<any> {
    return this._http.put<any>(Routes.palletStockApi + '/UpdatePalletStock', this.getFormDataUpdate(request))
  }

  updatePalletStockAdmin(request: UpdatePalletStockRequestAdmin): Observable<any> {
    return this._http.put<any>(Routes.palletStockApi + '/UpdatePalletStockAdmin', this.getFormDataUpdateAdmin
      (request))
  }

  updatePalletStockWithRules(stockId: number): Observable<any> {
    return this._http.post<any>(Routes.palletStockApi + '/UpdatePalletStockWithRules', {stockId})
  }

  getStock(): Observable<Stock[]> {
    return this._http.get<Stock[]>(Routes.palletStockApi + '/GetStock')
  }

  getStockPaged(pageNumber: number = 1, pageSize: number= 10): Observable<PageResult<Stock>> {
    return this._http.get<PageResult<Stock>>(Routes.palletStockApi + '/GetStockPaged', {params: {pageNumber, pageSize}})
  }

  getStockPagedAdmin(pageNumber: number, pageSize: number, username: string): Observable<PageResult<Stock>>
  {
    return this._http.get<PageResult<Stock>>(Routes.palletStockApi + '/GetStockAdminPaged', {params: {pageNumber, pageSize, username}})
  }

  createFormatPalletStock(request: CreateFormatPalletStockRequest): Observable<FormatPalletStock[]> {
    return this._http.post<FormatPalletStock[]>(Routes.palletStockApi + '/CreateFormatPalletStock', request)
  }

  getColumns(): Observable<StockColumn[]> {
    return this._http.get<StockColumn[]>(Routes.palletStockApi + '/GetColumns')
  }

  getStockFormatColumns(stockId: number): Observable<StockColumn[]> {
    return this._http.get<StockColumn[]>(Routes.palletStockApi + '/GetFormatStockColumnByStockId', {params: {stockId}})
  }

  updateFormatPalletStock(updateFormatPalletStock: UpdateFormatPalletStock): Observable<StockColumn[]>
  {
    return this._http.put<StockColumn[]>(Routes.palletStockApi + '/UpdateFormatPalletStock', updateFormatPalletStock)
  }

  getUnUsedStockColumn(formatId: number): Observable<StockColumn[]>
  {
    return this._http.get<StockColumn[]>(Routes.palletStockApi + '/GetNotUsedColumn', {params: {formatId}})
  }

  getFormatColumns(formatId: number): Observable<StockColumn[]>{
    return this._http.get<StockColumn[]>(Routes.palletStockApi + '/GetFormatColumns', {params: {formatId}})
  }

  getFormatPreview(request: PalletStockPreviewRequest): Observable<PalletStockPreviewResponse>
  {
    return this._http.post<PalletStockPreviewResponse>(Routes.palletStockApi + '/GetPalletFormatPreview',  this.getFormatPreviewData(request))
  }

  deleteStock(stockId: number): Observable<any>
  {
    return this._http.delete<any>(Routes.palletStockApi + '/DeleteStock',  {params: {stockId}})
  }

  getFormDataCreate(request: CreatePalletStockRequest): FormData {
    let formData = new FormData()
    if(request) {
      formData.append("stockName", request.stockName ? request.stockName.trim() : '')
      formData.append("formatPalletStockId", request.formatPalletStockId ? request.formatPalletStockId.toString() : '')
      formData.append("fridgeStorageId", request.fridgeStorageId ? request.fridgeStorageId.toString() : '')
      formData.append('file', request.file)
    }
    return formData
  }

    getFormDataCreateAdmin(request: CreatePalletRequestAdmin): FormData {
    let formData = new FormData()
    if(request) {
      formData = this.getFormDataCreate(request)
      formData.append('username', request.username)
    }
    return formData
  }

  getFormDataUpdate(request: UpdatePalletStockRequest): FormData {
  let formData = new FormData()
  if(request) {
    formData.append("stockId", request.stockId ? request.stockId.toString() : '')
    formData.append("formatPalletStockId", request.formatPalletStockId ? request.formatPalletStockId.toString() : '')
    formData.append("fridgeStorageId", request.fridgeStorageId ? request.fridgeStorageId.toString() : '')
    formData.append('file', request.file)
    formData.append('stockName', request.stockName)
  }
  return formData
  }

  getFormDataUpdateAdmin(request: UpdatePalletStockRequestAdmin): FormData {
  let formData = new FormData()
  formData = this.getFormDataUpdate(request)
  if(request) {
      formData.append('username', request.username);
  }
  return formData
  }

  getFormatPreviewData(request: PalletStockPreviewRequest)
  {
    let formData = new FormData()
    if(request) {
      if(request.file)
      {
        formData.append('file', request.file)
      }
      formData.append('columns', request.columns.length > 0 ? JSON.stringify(request.columns) : "[]")
    }

    return formData;
  }

  getStockStats(stockId: number): Observable<Stock>
  {
    return this._http.get<Stock>(Routes.palletStockApi + '/GetStockStats', {params: {stockId}})
  }

  getUnUsedStockColumnRule(stockId: number): Observable<StockColumn[]>
  {
    return this._http.get<StockColumn[]>(Routes.palletStockApi + '/GetUnUsedColumnsRule', {params: {stockId}})
  }

  getPalletStockImportProcesses(): Observable<PalletStockImport[]>
  {
    return this._http.get<PalletStockImport[]>(Routes.palletStockApi + '/GetPalletStockImportProcesses')
  }

  getPalletStockImportProcessesAdmin(username: string): Observable<PalletStockImport[]>
  {
    return this._http.get<PalletStockImport[]>(
      Routes.palletStockApi + '/GetPalletStockImportProcessesAdmin', {params: {username}})
  }

  rollBackVersion(stockId: number, version: number): Observable<any>
  {
    return this._http.put<any>(Routes.palletStockApi + '/RollBackStockVersion', { stockId, version })
  }

  downloadPalletStockImportErrors(importId: string): Observable<any>
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream'
    })
    return this._http.get(Routes.palletStockApi + '/DownloadPalletStockImportErrors', { params: { importId }, headers: headers, observe: 'response', responseType: 'blob' as 'json'})
  }

}

